import { OrganizationId } from 'yeself-common/typings/application/Application';

export const FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST =
    'application/FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST';
export const FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS =
    'application/FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS';
export const FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL = 'application/FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL';
export const FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST =
    'application/FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST';
export const FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS =
    'application/FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS';
export const FETCH_MEMBER_ORGANIZATIONS_LIST_FAIL = 'application/FETCH_MEMBER_ORGANIZATIONS_LIST_FAIL';

export type OrganizationsState = {
    adminOrganizations: {
        data: Organization[];
        isFailed: boolean;
        isLoading: boolean;
    };
    memberOrganizations: {
        data: Organization[];
        isFailed: boolean;
        isLoading: boolean;
    };
};

export type Organization = {
    id: OrganizationId;
    name: string;
};

type FetchAdminOrganizationsListRequestAction = {
    type: typeof FETCH_ADMIN_ORGANIZATIONS_LIST_REQUEST;
};

type FetchAdminOrganizationsListSuccessAction = {
    type: typeof FETCH_ADMIN_ORGANIZATIONS_LIST_SUCCESS;
    payload: { data: Record<string, string>[] };
};

type FetchAdminOrganizationsListFailAction = {
    type: typeof FETCH_ADMIN_ORGANIZATIONS_LIST_FAIL;
};

type FetchMemberOrganizationsListRequestAction = {
    type: typeof FETCH_MEMBER_ORGANIZATIONS_LIST_REQUEST;
};

type FetchMemberOrganizationsListSuccessAction = {
    type: typeof FETCH_MEMBER_ORGANIZATIONS_LIST_SUCCESS;
    payload: { data: Record<string, string>[] };
};

type FetchMemberOrganizationsListFailAction = {
    type: typeof FETCH_MEMBER_ORGANIZATIONS_LIST_FAIL;
};

export type OrganizationsActionTypes =
    | FetchAdminOrganizationsListRequestAction
    | FetchAdminOrganizationsListSuccessAction
    | FetchAdminOrganizationsListFailAction
    | FetchMemberOrganizationsListRequestAction
    | FetchMemberOrganizationsListSuccessAction
    | FetchMemberOrganizationsListFailAction;
